module.exports = __webpack_public_path__ + "img/7_49.2d4e34a5.png";